import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Depot from '@/models/Depot.js'

export const useDepotStore = defineStore('depotStore', () => {
  let syncableModel = useSyncableModel(useApiResource('depots'), {
    className: Depot.modelName.name,
    paramKey: Depot.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
